module.exports = __webpack_public_path__ + "5519d978ac0d58298b8dce50b6fcca79.png";